enum FileMessageKey {
  DOWNLOAD_LOCAL_PPT_LOADING = 'DOWNLOAD_LOCAL_PPT_LOADING',
  TINGWU2_PPT_INIT = 'TINGWU2_PPT_INIT',
  TINGWU2_SHARE_MESSAGE = 'TINGWU2_SHARE_MESSAGE',
  TINGWU2_SCREENSHOT_PPT_LOADING = 'tingwu2_screenshot_ppt_loading',
}

const CURRENTTIME_TINGWU2 = 'currentTime_tingwu2';
const CHOOSEAGENDA_TINGWU2 = 'chooseAgenda_tingwu2';
const CHOOSETODOLIST_TINGWU2 = 'chooseTodoList_tingwu2';
const CHANGE_BOX_TAB_TINGWU2 = 'change_box_tab_tingwu2';

const headerH = 89;
const audioH = 97;

const CLOSE_QA_ALLS = 'close_QA_alls';

export {
  FileMessageKey,
  CURRENTTIME_TINGWU2,
  CHOOSEAGENDA_TINGWU2,
  CHANGE_BOX_TAB_TINGWU2,
  CHOOSETODOLIST_TINGWU2,
  headerH,
  audioH,
  CLOSE_QA_ALLS,
};
